module.exports = __webpack_public_path__ + "img/selected2-min.2f8eaa5b.png";